import * as React from 'react';

import { convertUnits } from '@acceligentllc/shared/utils/unitConversion';

import type { QuantityUnitType, PlainUnitEnum } from '@acceligentllc/shared/enums/quantityUnit';

import Tooltip from 'af-components/Tooltip';

import styles from './styles.module.scss';
import TooltipContent from './TooltipContent';

export const regularDollarFormatter = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
	maximumFractionDigits: 4,
});

export const preciseDollarFormatter = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
	maximumFractionDigits: 8,
});

interface OwnProps {
	materialUnit: Nullable<PlainUnitEnum>;
	quantityUnit: Nullable<QuantityUnitType>;
	materialCost: Nullable<number>;
}

type Props = OwnProps;

const ConvertedMaterialCost: React.FC<Props> = (props) => {
	const { materialCost, materialUnit, quantityUnit } = props;

	const needsConversion = !!quantityUnit && materialUnit && materialUnit !== quantityUnit;

	const convertedValue = React.useMemo(() => {
		if (!needsConversion || !materialCost) {
			return null;
		}
		// target and source are invertred because material cost is expressed as $/UNIT - the unit is in the denominator
		return convertUnits(materialCost, quantityUnit, materialUnit);
	}, [materialCost, needsConversion, materialUnit, quantityUnit]);

	if (!materialCost) {
		return '';
	}

	if (!needsConversion) {
		return `${regularDollarFormatter.format(materialCost)} per ${materialUnit}`;
	}

	return (
		<Tooltip containerClassName={styles.ConvertedMaterialCost} message={<TooltipContent materialUnit={materialUnit} trackedUnit={quantityUnit} />}>
			{`${preciseDollarFormatter.format(convertedValue ?? materialCost)} per ${quantityUnit} (${preciseDollarFormatter.format(materialCost)} per ${materialUnit})`}
		</Tooltip>
	);
};

export default React.memo(ConvertedMaterialCost);
